import { AssetsAtomicQueryV2 } from "../models/bulkActions";
import { ExportFileFormat, ExportJob, ExportResponse } from "../models/import";
import { ProjectId } from "../types";
import { Endpoints } from "./constants";
import { AssetsHttpClient } from "./createAssetsHttpClient";

export const getExportClient = (
  http: AssetsHttpClient,
  projectId: ProjectId
) => {
  const base = http.getAssetsServiceBasePath(projectId);

  return {
    get: (token: string): Promise<ExportResponse> =>
      http.get<ExportResponse>(
        `${base}/${Endpoints.Downloads}?token=${token}`
      ),

    exportAssets: (
      downloadTitle?: string,
      query?: AssetsAtomicQueryV2,
      includeSubLocations?: boolean,
      fileFormat?: ExportFileFormat,
      includedModules: ExportJob["metadata"]["includedModules"] = ["assets"]
    ): Promise<ExportJob> =>
      http.post<ExportJob>(`${base}/${Endpoints.AssetExports}`, {
        body: JSON.stringify({
          query,
          options: {
            createProgressTrackingChannel: true,
            ...(downloadTitle && { downloadTitle }),
            ...(includeSubLocations && { includeSubLocations }),
            ...(fileFormat && { outputFormat: fileFormat }),
          },
          includedModules,
        }),
      }),

    getAssetExport: (assetExportJobId: ExportJob["id"]): Promise<ExportJob> =>
      http.get<ExportJob>(
        `${base}/${Endpoints.AssetExports}/${assetExportJobId}?includeSignedUrl=true`
      ),

    exportProjectSettings: (): Promise<ExportJob> =>
      http.post<ExportJob>(`${base}/${Endpoints.ProjectExports}`, {
        body: JSON.stringify({
          options: {
            createProgressTrackingChannel: true,
          },
          includedModules: ["categories", "status_sets", "custom_attributes"],
        }),
      }),

    getProjectSettingsExport: (
      projectSettingsExportJobId: ExportJob["id"]
    ): Promise<ExportJob> =>
      http.get<ExportJob>(
        `${base}/${Endpoints.ProjectExports}/${projectSettingsExportJobId}?includeSignedUrl=true`
      ),
  };
};

/**
 * The shape returned by {@link getExportClient}.
 * Exported so consumers can type variables without spelling out
 * `ReturnType<typeof getExportClient>`.
 */
export type ExportClient = ReturnType<typeof getExportClient>;
